import { ThemeOptions } from '@mui/material';

// const HEADING_FONT = 'Europa, sans-serif';
const BODY_FONT =
  '"Microsoft YaHei", "PingFangSC-Regular", "sans-serif", SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace';
//'"Open Sans", sans-serif';

// const MONO_FONT =
// 'SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace';
const themeConfig: ThemeOptions =  {

  palette: {
    primary: {
      main: '#005ae7',
      // main: '#f5202c',
    },
    secondary:{
      main:'#FF0000',
    },
    background: {
      default: '#e5e5e5',
    },
  },
  // sidebar: {
  //   width: 240,
  //   closedWidth: 55,
  //   fontFamily: BODY_FONT,
  // },
  typography: {
    fontFamily: BODY_FONT,
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        // 普通弹窗避开 header；fullScreen（分享 PDF 等）不套上下 64px，否则会出现灰边/滚动条
        container: ({ ownerState }) =>
          ownerState.fullScreen
            ? {}
            : {
              alignItems: 'flex-start !important',
              paddingTop: '64px !important',
              paddingBottom: '64px !important',
            },
        paper: ({ ownerState }) =>
          ownerState.fullScreen
            ? {}
            : {
              marginTop: 'auto !important',
              marginBottom: 'auto !important',
              maxHeight: 'calc(100vh - 128px) !important',
            },
      },
      defaultProps: {
        // 确保 scroll 模式设置正确
        scroll: 'body'
      }
    }
  },
  // overrides: {
  //   OrbitMenuItemLink: {
  //     root: {
  //       borderLeft: '3px solid #fff',
  //     },
  //     active: {
  //       borderLeft: '3px solid #4f3cc9',
  //     },
  //   },
  //   MuiTab:{
  //     root:{
  //       lineHeight:'1.75',
  //     }
  //   },
  //   MuiAppBar: {
  //     colorSecondary: {
  //       color: '#808080',
  //       backgroundColor: '#fff',
  //     },
  //   },
  //   MuiLinearProgress: {
  //     colorPrimary: {
  //       backgroundColor: '#f5f5f5',
  //     },
  //     barColorPrimary: {
  //       backgroundColor: '#d7d7d7',
  //     },
  //   },
  //   MuiFilledInput: {
  //     root: {
  //       backgroundColor: 'rgba(0, 0, 0, 0.04)',
  //       '&$disabled': {
  //         backgroundColor: 'rgba(0, 0, 0, 0.04)',
  //       },
  //     },
  //   },
  //   MuiTableRow: {
  //     root: {
  //       '&$selected': {
  //         backgroundColor: '#6586ff20',
  //         '&:hover': {
  //           backgroundColor: '#6586ff20',
  //         }
  //       }
  //     }
  //   },
  // },
};
export default themeConfig;
